
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ci-ais-search",
})
export default class extends Vue {
  @Prop({ default: "" }) public label!: string;
  @Prop({ default: "product_search" }) public name!: string;
  @Prop({ default: false }) public clearable!: boolean;
}
